import React from 'react'
import styled from 'styled-components'
import { mediaqueries } from '../../utils/mediaqueries'

const Banner = styled.a`
  color: white;
  background: ${({ secondary }) => (secondary ? '#004445' : '#1f2228')};
  text-align: center;
  padding: 6px 10px;
  font-size: 11px;
  line-height: 20px;
  display: flex;
  flex-wrap: wrap;

  span {
    flex: 0 0 100%;

    &:nth-child(2),
    &:nth-child(4) {
      display: none;
    }
  }

  a {
    color: inherit;
  }

  @media ${mediaqueries.md} {
    margin-bottom: 0;
    display: block;
    font-size: 13px;
    padding: 12px 30px;

    span:nth-child(2),
    span:nth-child(4) {
      display: initial;
    }
  }
`

export const AttentionBanner = ({ children, secondary = false }) => (
  <Banner secondary={secondary}>{children}</Banner>
)
